import { render } from "./ElectionPolicyView.vue?vue&type=template&id=f720ef24&scoped=true"
import script from "./ElectionPolicyView.vue?vue&type=script&lang=js"
export * from "./ElectionPolicyView.vue?vue&type=script&lang=js"

import "./ElectionPolicyView.vue?vue&type=style&index=0&id=f720ef24&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f720ef24"]])

export default __exports__